import { SpaceType } from '~/packages/general/variable/spaceTime.types'

/**
 * Determina uma resolução otimizada para cada tipo de delimitação, tomando a resolução 8 como padrão.
 * @param space Parâmetro space com space.delimitationType para determinar resolução h3index.
 * @returns number relativo a resolução d h3index.
 */

export default function h3ResolutionResolve(delimitationType?: SpaceType | null | undefined) {
  if (delimitationType) {
    switch (delimitationType) {
      case 'country':
        return 5
      case 'macroRegion':
        return 5
      case 'state':
        return 6
      case 'mesoRegion':
        return 7
      case 'microRegion':
        return 7
      case 'municipality':
        return 8
      case 'district':
        return 10
      case 'neighborhood':
        return 10
      case 'street':
        return 11
      default:
        return 8
    }
  }
  return 8
}

export function h3ResolutionResolveByZoom(
  zoom: number | undefined,
  delimitationType?: SpaceType | null | undefined,
  maxCurrentResolution?: number,
) {
  if (zoom === undefined) return 6

  const minResolution = 2
  const maxResolution = maxCurrentResolution ?? h3ResolutionResolve(delimitationType)

  const minZoom = 4
  const maxZoom =
    maxResolution <= 7
      ? 12
      : maxResolution === 8
      ? 14
      : maxResolution === 9
      ? 16
      : maxResolution === 10
      ? 18
      : maxResolution === 11
      ? 19
      : 16

  const clampedZoom = Math.max(minZoom, Math.min(maxZoom, zoom))

  const resolution =
    minResolution +
    ((clampedZoom - minZoom) / (maxZoom - minZoom)) * (maxResolution - minResolution)

  return Math.round(resolution)
}
